/**
 * atonce/consult-booking — kalendarz Calendly 640 × 504 skalowany do szerokości komórki, gdy komórka ma ≥ 640 px (makieta online: scale 1,18875 @1440,
 * 1,25 @1920 i @1100 — maks. 1,25×); węższa komórka (768, telefon): kalendarz 100 % × 700 px (CSS). ResizeObserver na komórce, bez przeliczania w pętli przewijania.
 */
( function () {
	const cals = [ ...document.querySelectorAll( '[data-cb-cal]' ) ];
	if ( ! cals.length ) {
		return;
	}
	const BASE_W = 640;
	const BASE_H = 504;
	const MAX = 1.25;
		const fit = ( cal ) => {
		const ifr = cal.querySelector( 'iframe' );
		if ( ! ifr ) {
			return;
		}
		const cell0 = cal.parentElement;
		const cs0 = getComputedStyle( cell0 );
		const avail0 = cell0.clientWidth - parseFloat( cs0.paddingLeft ) - parseFloat( cs0.paddingRight );
		if ( avail0 < BASE_W ) { // makieta: poniżej 640 px szerokości komórki kalendarz 100 % × 700 (np. 768), od 640 skalowany (także w 1 kolumnie przy 1100)
			cal.style.width = '100%'; // inline, bo CSS od 900 px daje zapas 640 × 504 bez JS (makieta przy 1200: komórka 637 px → 100 % × 700)
			cal.style.height = '700px';
			cal.style.maxWidth = '';
			ifr.style.width = '';
			ifr.style.height = '';
			ifr.style.transform = '';
			return;
		}
		const cell = cal.parentElement;
		const cs = getComputedStyle( cell );
		const avail = cell.clientWidth - parseFloat( cs.paddingLeft ) - parseFloat( cs.paddingRight );
		const scale = Math.min( MAX, avail / BASE_W );
		cal.style.maxWidth = 'none';
		cal.style.width = ( BASE_W * scale ).toFixed( 2 ) + 'px';
		cal.style.height = ( BASE_H * scale ).toFixed( 2 ) + 'px';
		ifr.style.width = BASE_W + 'px';
		ifr.style.height = BASE_H + 'px';
		ifr.style.transform = 'scale(' + scale.toFixed( 5 ) + ')';
	};
	const all = () => cals.forEach( fit );
	if ( 'ResizeObserver' in window ) {
		const ro = new ResizeObserver( all );
		cals.forEach( ( c ) => ro.observe( c.parentElement ) );
	} else {
		window.addEventListener( 'resize', all );
	}
	all();
} )();
